import { render, staticRenderFns } from "./user-beastcoin.vue?vue&type=template&id=559d960d&scoped=true&"
import script from "./user-beastcoin.vue?vue&type=script&lang=js&"
export * from "./user-beastcoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d960d",
  null
  
)

export default component.exports